import { render } from "./CohortManager.vue?vue&type=template&id=3e8d5bb1"
import script from "./CohortManager.vue?vue&type=script&lang=js"
export * from "./CohortManager.vue?vue&type=script&lang=js"
script.render = render

export default script